// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3KeFd","header":"ReportDetails_header__2t3t2","title":"ReportDetails_title__1WYXL","left":"ReportDetails_left__3J_XB"};